import { connect } from 'react-redux';

import { favoriteTrackToggle } from 'actions/favoriteTrack-actions';
import { getIsFavoriteTrack } from 'store/reducers/favorites';

import Track from './Track';

const mapStateToProps = (state, ownProps) => ({
  isFavorite: getIsFavoriteTrack(state, ownProps),
});

function mapDispatchToProps(dispatch, ownProps) {
  return {
    onFavoriteToggle: () => dispatch(favoriteTrackToggle(ownProps.track)),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(Track);
